import { EXCLUSION_KEY, isUsageEvent, measurementAllowed, type UsageEvent } from './usage-events';

let started = false;
let excluded = false;

export function privacySignalEnabled(): boolean {
  return navigator.doNotTrack === '1'
    || ('globalPrivacyControl' in navigator && navigator.globalPrivacyControl === true);
}

export function isMeasurementExcluded(): boolean {
  try {
    return excluded || localStorage.getItem(EXCLUSION_KEY) === '1';
  } catch {
    return excluded;
  }
}

export function saveMeasurementPreference(value: boolean): boolean {
  excluded = value;
  try {
    if (value) localStorage.setItem(EXCLUSION_KEY, '1');
    else localStorage.removeItem(EXCLUSION_KEY);
    return true;
  } catch {
    return false;
  }
}

function enabled(): boolean {
  return measurementAllowed(location.origin, isMeasurementExcluded(), privacySignalEnabled());
}

export function startMeasurement(): void {
  if (started) return;
  started = true;
  // Explicit QA link; only this fixed preference is read, never other query values.
  const choice = new URLSearchParams(location.search).get('rr_exclude');
  if (choice === '1' || choice === '0') saveMeasurementPreference(choice === '1');
  if (!enabled()) return;
  const script = document.createElement('script');
  script.type = 'module';
  script.src = 'https://static.cloudflareinsights.com/beacon.min.js';
  script.dataset.cfBeacon = JSON.stringify({ token: 'b984cf6d82b54b298349d5df5d3e1c13' });
  document.head.append(script);
}

export function trackUsage(event: UsageEvent): void {
  // Runtime allowlist is intentional: arbitrary DOM strings must never become telemetry.
  if (!isUsageEvent(event) || !enabled()) return;
  void fetch(`/_usage/v2/live/${event}`, {
    method: 'POST',
    body: null,
    cache: 'no-store',
    credentials: 'omit',
    referrerPolicy: 'no-referrer',
    keepalive: true,
  }).catch(() => undefined); // Measurement failures never interrupt local analysis.
}
